import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import {
  chatApiClient,
  ChatDeleteErrorResponse,
  ChatDeleteResponse,
} from '@src/api/shared/community/chatApiClient';
import { ERROR_MESSAGES } from '@src/utils/errorMessages';
import { useCallback, useState } from 'react';

export interface UseChatDeleteResult {
  isDeleting: boolean;
  errorMessage: string | null;
  deleteMessage(chatId: number): Promise<boolean>;
}

export function useChatDelete(channelCode?: string): UseChatDeleteResult {
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const deleteMessage = useCallback(
    async (chatId: number): Promise<boolean> => {
      if (!channelCode) {
        setErrorMessage(ERROR_MESSAGES.DELETE.CHANNEL_REQUIRED);
        return false;
      }

      setIsDeleting(true);
      setErrorMessage(null);

      try {
        const apiResult = await chatApiClient.delete(channelCode, chatId);

        handleApiResponse<ChatDeleteResponse, ChatDeleteErrorResponse>(
          apiResult,
          () => {},
          () => {
            setErrorMessage(ERROR_MESSAGES.DELETE.FAILED);
          },
        );

        return apiResult.result === 'success';
      } catch {
        setErrorMessage(ERROR_MESSAGES.DELETE.FAILED);
        return false;
      } finally {
        setIsDeleting(false);
      }
    },
    [channelCode],
  );

  return {
    isDeleting,
    errorMessage,
    deleteMessage,
  };
}
